module.exports = __webpack_public_path__ + "img/m_skjl.24e881bd.png";